"use client";
import React, { useState } from "react";
import ReactPaginate from "react-paginate";
import BlogSingleCard from "./BlogSingleCard/BlogSingleCard";
import "./paginate.css";

const BlogsGrid = ({ blogs, langData }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const cardsPerPage = 6;
  const pagesVisited = currentPage * cardsPerPage;

  const displayBlogs = blogs.slice(pagesVisited, pagesVisited + cardsPerPage);

  const pageCount = Math.ceil(blogs.length / cardsPerPage);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
    const el = document.getElementById("blog_list");
    const height = el.getBoundingClientRect().top + window.scrollY;
    window.scrollTo(0, height);
  };

  return (
    <div className={""}>
      <div className="sm:grid-cols-2 sm:grid grid gap-[20px] max-w-[668px] mx-auto lg:max-w-[1006px] lg:grid-cols-3 xl:gap-[40px]">
        {displayBlogs.map((item, idx) => (
          <BlogSingleCard
            key={idx}
            data={item}
            readMoreLabel={langData?.readMoreLabel || "Read more"}
          />
        ))}
      </div>
      <div className="react-paginate-custom mt-[28px]">
        <ReactPaginate
          previousLabel={langData?.previous}
          nextLabel={langData?.next}
          pageCount={pageCount}
          onPageChange={handlePageChange}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
        />
      </div>
    </div>
  );
};

export default BlogsGrid;
